import { AppLanguage } from '../services/language.service';
import { APP_TEXT_EN } from './app-text-en';
import { APP_TEXT_ES } from './app-text-es';

type WidenValue<TValue> = TValue extends string
  ? string
  : TValue extends number
    ? number
    : TValue extends boolean
      ? boolean
      : TValue extends readonly (infer TItem)[]
        ? readonly WidenValue<TItem>[]
        : TValue extends object
          ? { [TKey in keyof TValue]: WidenValue<TValue[TKey]> }
          : TValue;

export type AppTextSchema = {
  [TPage in keyof typeof APP_TEXT_ES]: WidenValue<
    (typeof APP_TEXT_ES)[TPage]
  >;
};
export type AppTextPage = keyof AppTextSchema;
export type AppPageTexts<TPage extends AppTextPage> = AppTextSchema[TPage];

const APP_TEXTS: Record<AppLanguage, AppTextSchema> = {
  es: APP_TEXT_ES,
  en: APP_TEXT_EN,
};

export function getAppTexts<TPage extends AppTextPage>(
  page: TPage,
  language: AppLanguage
): AppPageTexts<TPage> {
  return APP_TEXTS[language][page];
}
